module.exports = __webpack_public_path__ + "img/icon-kitchen.70a8f9d5.svg";